import MyDocuments from "../views/MyDocuments";

const menu = [
  {title: "Мои документы", icon: "fa fa-camera", url: "/docs", id: 5},
];

const routes = [
  {
    path: "/docs",
    name: "docs",
    component: MyDocuments,
    meta: {
      forAuth: true
    }
  }
];

export default { menu, routes };
